import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

// Utility: default last 30 days range
function getDefaultRange() {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - 30);

  return {
    fromDate: start.toISOString().split("T")[0],
    toDate: end.toISOString().split("T")[0],
  };
}

export default function useTotalTimeByGroup(range = null) {
  const [totalChargingTime, setTotalChargingTime] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { send, isConnected, registerHandler } = useWebSocketContext();
  const mountedRef = useRef(true);
  const groupId = localStorage.getItem("group_id");

  const fetchTotalTime = useCallback(async () => {
    if (!mountedRef.current) return;
    if (!isConnected) {
      setError("WebSocket not connected");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const { fromDate, toDate } = range || getDefaultRange();

      const payload = {
        group_id: groupId?.toString(),
        start_date: fromDate,
        end_date: toDate,
      };

      console.log("Payload being sent (total time):", payload);

      const response = await send("cms_get_total_time_by_group_id", payload);

      if (!response || response.type !== "cms_get_total_time_by_group_id_response") {
        throw new Error("Invalid response from server");
      }

      if (typeof response.data !== "number") {
        throw new Error("Server did not return a valid total time");
      }

      setTotalChargingTime(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      if (mountedRef.current) setIsLoading(false);
    }
  }, [isConnected, send, groupId, range]);

  // Live updates subscription
  useEffect(() => {
    const unregister = registerHandler("total_charging_time_update", (msg) => {
      if (typeof msg.data === "number" && mountedRef.current) {
        setTotalChargingTime(msg.data);
      }
    });
    return () => unregister();
  }, [registerHandler]);

  // Initial fetch
  useEffect(() => {
    mountedRef.current = true;
    fetchTotalTime();
    return () => {
      mountedRef.current = false;
    };
  }, [fetchTotalTime]);

  return { totalChargingTime, isLoading, error, refetch: fetchTotalTime };
}
